module.exports = __webpack_public_path__ + "static/media/new_PREPARATORIO_PARA_CERTIFICACAO_ITIL_E_COBIT-06.d7e15462.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/prep_cert/new_PREPARATORIO_PARA_CERTIFICACAO_ITIL_E_COBIT-06.png
// module id = 282
// module chunks = 0